import { api } from '@/shared/lib/api'
import { SearchParams } from '@workspace/lib/api'
import { useMutation } from '@tanstack/react-query'

export const useLoadMoreSearch = () => {
    return useMutation({
        mutationFn: async (params: SearchParams) => {
            const response = await api.searchGlobal.loadMore(params)
            return response
        },
        meta: {
            invalidates: [], // Khai báo mảng rỗng để chặn việc gọi lại các API khác (me, search, summary...)
        },
    })
}
